{/* Auto-generated icon - do not edit */}
import React from 'react'

interface UnhideIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const UnhideIcon = React.forwardRef<SVGSVGElement, UnhideIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 150 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M78.1299 0.119289C91.6049 0.498033 104.499 3.4745 116.483 9.72082C125.288 14.2758 133.363 20.1342 140.437 27.1005C142.541 29.2994 144.525 31.6107 146.382 34.0244C148.673 36.8431 149.058 40.3272 149.213 43.7496C149.191 45.2771 148.746 46.7682 147.93 48.0564C140.122 61.1215 129.901 71.5656 115.908 78.0245C96.1172 87.1602 75.8279 89.2652 54.8947 82.7271C39.5393 77.929 25.1913 71.0835 12.566 60.8833C8.97825 57.9842 5.73406 54.7881 3.47043 50.7305C2.59314 49.045 1.82378 47.305 1.16709 45.521C0.393457 43.59 0.868499 41.7158 1.88287 40.053C2.7125 38.7733 3.66712 37.5801 4.73266 36.4912C12.2408 28.368 20.6116 21.0965 29.6955 14.8067C38.1783 8.94946 47.7343 4.8455 57.8084 2.73327C64.4705 1.30857 71.1984 -0.177689 78.1299 0.119289ZM9.87596 44.5037C12.1428 48.4148 15.5809 50.8116 19.0261 53.1835C31.0476 61.4602 44.2229 67.179 58.2608 70.9612C73.0307 74.9409 87.5403 73.7739 101.92 68.8771C116.42 63.9368 127.74 54.6605 137.461 43.1111C137.741 42.8492 137.939 42.5113 138.031 42.1384C138.068 41.4188 138.208 40.4547 137.824 40.0099C133.348 34.8226 128.775 29.7138 123.054 25.844C96.7471 8.05736 69.2198 6.98778 40.9844 20.4224C29.9617 25.6666 20.3893 33.3089 11.4448 41.6465C10.6711 42.3621 10.3647 43.5761 9.87277 44.5037H9.87596Z" fill={color}/>
<path d="M96.2342 41.4864C96.2915 45.182 94.9856 48.7679 92.5684 51.5528C87.6065 57.2994 81.4897 60.6452 73.6643 60.1487C71.1027 60.0289 68.6015 59.3276 66.3483 58.0972C64.095 56.8668 62.148 55.1393 60.6535 53.0445C59.1591 50.9495 58.1558 48.5417 57.7193 46.0013C57.2826 43.461 57.424 40.8541 58.1326 38.3765C58.9677 35.451 60.2776 32.684 62.0092 30.1874C69.7434 19.2915 84.0286 21.0132 91.0836 27.5918C94.9544 31.202 96.3136 35.8366 96.2342 41.4864ZM76.3769 35.0143C72.9095 34.8286 69.7532 36.5882 68.9997 38.8037C68.1057 41.434 68.1656 44.0498 70.0675 46.3079C70.5509 46.8834 71.141 47.359 71.8047 47.7078C73.1431 48.4384 74.6598 48.772 76.1791 48.6701C77.699 48.5681 79.1578 48.0349 80.3875 47.1321C84.8907 44.1002 84.5693 38.5493 79.7544 36.2081C78.6594 35.7269 77.5305 35.328 76.3769 35.0143Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="149" height="87" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

UnhideIcon.displayName = 'UnhideIcon'
